import {
  ApiBlueprint,
  configApiRef,
  createFrontendModule,
  discoveryApiRef,
  fetchApiRef,
  githubAuthApiRef,
  identityApiRef,
} from '@backstage/frontend-plugin-api';
import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import {
  makeFieldSchema,
  scaffolderApiRef,
} from '@backstage/plugin-scaffolder-react';
import { scmIntegrationsApiRef } from '@backstage/integration-react';
import { VerifiedTokenScaffolderClient } from './VerifiedTokenScaffolderClient';
import { freshGithubToken } from './freshGithubToken';

/**
 * Shared SCM concerns for the scaffolder.
 *
 * Deliberately not under modules/dataset: every template that mutates GitHub
 * needs this field now that scaffolder.requireScmUserCredentials is on, not
 * just the dataset ones.
 */
const githubUserCredential = FormFieldBlueprint.make({
  name: 'github-user-credential',
  params: {
    field: async () =>
      createFormField({
        name: 'GithubUserCredential',
        schema: makeFieldSchema({ output: z => z.string() }),
        component: (await import('./GithubUserCredential'))
          .GithubUserCredential,
      }),
  },
});

// Same kind and name as the scaffolder plugin's own api extension, so this
// replaces it rather than sitting beside it.
const scaffolderApi = ApiBlueprint.make({
  params: defineParams =>
    defineParams({
      api: scaffolderApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        scmIntegrationsApi: scmIntegrationsApiRef,
        fetchApi: fetchApiRef,
        identityApi: identityApiRef,
        githubAuth: githubAuthApiRef,
        configApi: configApiRef,
      },
      factory: ({ githubAuth, configApi, ...clientDeps }) =>
        new VerifiedTokenScaffolderClient(clientDeps, () =>
          freshGithubToken({
            githubAuth,
            discoveryApi: clientDeps.discoveryApi,
            configApi,
          }),
        ),
    }),
});

export const scmScaffolderModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [githubUserCredential, scaffolderApi],
});
